import { render, staticRenderFns } from "./user-password-dialog.vue?vue&type=template&id=36e3f6d7&scoped=true"
import script from "./user-password-dialog.vue?vue&type=script&lang=js"
export * from "./user-password-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-password-dialog.vue?vue&type=style&index=0&id=36e3f6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3f6d7",
  null
  
)

export default component.exports